module.exports = __webpack_public_path__ + "static/media/ends_with_k.101262da.mp3";